import { GET_AUTHORITY_EXIST_FOR_LOGGED_IN_USER } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_AUTHORITY_EXIST_FOR_LOGGED_IN_USER_KEY } from '../../constants/queryKeys';

// =============================================================================
// Query
// =============================================================================
interface Input {
  authorityName: string;
}

export const useGetCheckAuthorityExist = ({ authorityName }: Input) => {
  const getCheckAuthorityExist = async () => {
    const res = await axiosClient.get<void>(GET_AUTHORITY_EXIST_FOR_LOGGED_IN_USER(authorityName));

    return res.data;
  };

  return useCustomQuery(
    [GET_AUTHORITY_EXIST_FOR_LOGGED_IN_USER_KEY, authorityName],
    getCheckAuthorityExist
  );
};
